<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
    <circle cx="4" cy="12" r="3" fill="currentColor">
      <animate
        id="3-dots-bounce-0"
        attributeName="cy"
        begin="0;3-dots-bounce-1.end+0.25s"
        calcMode="spline"
        dur="0.6s"
        keySplines=".33,.66,.66,1;.33,0,.66,.33"
        values="12;6;12"
      />
    </circle>
    <circle cx="12" cy="12" r="3" fill="currentColor">
      <animate
        attributeName="cy"
        begin="3-dots-bounce-0.begin+0.1s"
        calcMode="spline"
        dur="0.6s"
        keySplines=".33,.66,.66,1;.33,0,.66,.33"
        values="12;6;12"
      />
    </circle>
    <circle cx="20" cy="12" r="3" fill="currentColor">
      <animate
        id="3-dots-bounce-1"
        attributeName="cy"
        begin="3-dots-bounce-0.begin+0.2s"
        calcMode="spline"
        dur="0.6s"
        keySplines=".33,.66,.66,1;.33,0,.66,.33"
        values="12;6;12"
      />
    </circle>
  </svg>
</template>
<script>
export default {
  name: "Loader"
};
</script>
